<script setup lang="ts">
import { computed, shallowRef, watch } from 'vue';
import { fluentIcons } from 'virtual:fluent-icons';

const props = defineProps({
    icon: {
        type: String,
        required: true
    }
});

/** Epion-egne ikoner (logo o.l.) som ikke finnes i Fluent. */
const localIcons = import.meta.glob('../../svg/*.svg');

const icon = shallowRef(null);
const isFluent = computed(() => props.icon in fluentIcons);

watch(
    () => props.icon,
    async name => {
        const load = fluentIcons[name] ?? localIcons[`../../svg/${name}.svg`];

        if (!load) {
            console.warn(`Ukjent ikon: ${name}`);
            icon.value = null;

            return;
        }

        icon.value = ((await load()) as { default: never }).default;
    },
    { immediate: true }
);
</script>

<template>
    <component
        v-if="icon"
        :is="icon"
        :fill="isFluent ? 'currentColor' : undefined"
        v-bind="$attrs"
        :height="null"
        :width="null"
    />
</template>
